var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-title": "Abbrechen",
        "modal-class": "email-category-edit-modal info-card editMode",
        "ok-title": "Speichern",
        size: "lg",
        title: "Kategorien bearbeiten",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center pt-4" },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _vm.availableCategories.length === 0
                ? _c("p", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n            Keine Kategorien für diese Mailbox konfiguriert.\n        "
                    ),
                  ])
                : _c(
                    "b-form-group",
                    {
                      staticClass: "info-card-element col-7 col-lg-9",
                      attrs: {
                        label: "Kategorien",
                        "label-for": "category-select",
                      },
                    },
                    [
                      _c("csp-form-select-searchable-with-tags", {
                        attrs: {
                          id: "category-select",
                          "close-on-select": false,
                          options: _vm.availableCategories,
                          placeholder: "Kategorien auswählen …",
                          values: _vm.selectedCategoryIds,
                        },
                        on: { change: _vm.onCategoryChange },
                      }),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }